module.exports = __webpack_public_path__ + "img/profile-dummy3-300x300.b0b28136.png";